export default __webpack_public_path__ + "static/media/cs-1.cf797113.jpg";